<template>
  <div>
    <b-modal
      size="xlt"
      v-if="true || !openClicked"
      ref="myModal"
      id="add-model"
      title="Spec Sheet"
      centered
      no-close-on-backdrop
      hide-footer
      body-class="find-modal-body"
    >
      <div class="row">
        <template v-for="confValue in configurations.Values">
          <div class="col-4" :key="confValue.Characteristic" v-if="confValue.Values && confValue.Values.length > 0 && configurations.Invisible.indexOf(confValue.Characteristic) < 0 && !configurations.Characteristics[confValue.Characteristic].Hidden">
            <div class="row">
              <div class="col">
                <b>{{ configurations.Characteristics[confValue.Characteristic].CharacteristicText }}:</b>
              </div>
              <div class="col">
                <span v-for="value in confValue.Values" :key="value.Value">
                  {{ getValue(value, configurations.Characteristics[confValue.Characteristic].Values)}}
                </span>
              </div>
            </div>
          </div>
        </template>
      </div>
    </b-modal>
  </div>
</template>

<script lang="ts">
import { Component, Prop } from 'vue-property-decorator'

import ModelEditor from '@/components/editor/modals/model-editor.vue'
import StatusBadge from '@/components/editor/status-badge.vue'
import EditorEditor from '@/components/editor/utility/editor-editor.vue'
import LoadingText from '@/components/utility/loading-text.vue'
import ConfigurableMaterialModal from '../modals/configurable-material-modal.vue'

import MxSite from '@/mixins/site'
import OrderProductTabs from './order-product-tabs.vue'
import OrderProductTopology from './order-product-topology.vue'

@Component({
  components: {
    'loading-text': LoadingText,
    'editor-editor': EditorEditor,
    'status-badge': StatusBadge,
    'model-editor': ModelEditor,
    'order-product-topology': OrderProductTopology,
    'order-product-tabs': OrderProductTabs,
    'configurable-material-modal': ConfigurableMaterialModal,
  },
})
export default class extends MxSite {
  @Prop()
  public configurations!: any

  public openClicked = false

  public mounted() {
  }

  public open() {
    this.openClicked = true
    const myModal: any = this.$refs.myModal
    myModal.show()
  }

  public getValue(value: string, options: any[]) {
    if (options && options.length > 0) {
      const values = options.filter(s => s.Value === value)
      if (values && values.length > 0) {
        return values[0].ValueText
      }
      return value
    }
    return value
  }
}
</script>
<style scoped>
.configurable-material-grid {
  max-height: 55vh;
  overflow-y: auto;
}

.config-material-card {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 140px;
  padding: 0.75rem;
  border: 2px solid #dee2e6;
  border-radius: 0.25rem;
  cursor: pointer;
  background: #fff;
  transition: border-color 0.15s ease, box-shadow 0.15s ease, background-color 0.15s ease;
}

.config-material-card:hover {
  outline: none;
  border-color: #007bff;
  background-color: #f0f7ff;
  box-shadow: 0 0.25rem 0.75rem rgba(0, 123, 255, 0.2);
}

.config-material-card:focus {
  outline: none;
  border-color: #007bff;
  background-color: #e7f1ff;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.35);
}

.config-material-card:active {
  background-color: #d9e9ff;
}

.config-material-card__pcn {
  font-weight: 600;
  word-break: break-word;
}

.config-material-card__desc {
  word-break: break-word;
  color: #6c757d;
  font-size: 0.875rem;
  margin-top: 0.25rem;
}

.config-material-card__thumb {
  margin-top: 0.5rem;
  text-align: center;
  pointer-events: none;
}

.config-material-card__img {
  max-height: 80px;
  max-width: 100%;
  object-fit: contain;
}

.config-material-highlight {
  padding: 0 0.12em;
  margin: 0 -0.02em;
  background-color: #fff3cd;
  color: inherit;
  border-radius: 0.15em;
  font-weight: inherit;
}
</style>
<style>
.find-modal-body {
  min-height: 200px;
}
.filter-dropdown {
  min-width: 600px !important;
  /* height: 200px!important; */
  /* overflow: auto; */
}
.filter-tab {
  overflow: auto;
  height: 350px !important;
}
.modal-dialog {
  max-width: 90% !important;
}

.input-quantity {
  width: 30px !important;
  text-align: center;
}

.mobile-tabs-content {
  height: 50vh;
  overflow: auto;
}

@media (max-width: 767px) {
  .category-browser {
    display: none;
  }
  .filter-dropdown {
    min-width: 100vw !important;
  }
  .mobile-field-dropdown {
    text-wrap: balance !important;
    line-height: initial !important;
    min-width: 40vw !important;
  }
}
</style>
